import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

import ModernTradeNewSidebar from "./ModernTradeNewSidebar";
import ViewTableFilterSearch from "./ViewTableFilterSearch";

import Header from "../../../compnents/Header";
import Footer from "../../../compnents/Footer";

import UploadFileIcon from "../../../assets/images/upload-file.png";
import "./ModernTradeNewFileUpload.scss";
import "../../../style.scss";


function ModernTradeNewFileUpload() {
    const [filterOption, setFilterOption] = useState("");
    
    return (
        <>
        {/* <!-- main header --> */}
        <Header />
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-2">
                    <ModernTradeNewSidebar />
                </div>
                <div className="col-md-10">
                    <Form>
                    <div className="card">
                        <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">Select Table</h4>
                            <Form.Select
                                name="filter_option"
                                className="form-control"
                                value={filterOption}
                                onChange={(e) => setFilterOption(e.target.value)}
                            >   
                                <option value="">Select Option</option>
                                <option value="table_1">Table 1</option>
                                <option value="table_2">Table 2</option>
                                <option value="table_3">Table 3</option>
                                <option value="table_4">Table 4</option>
                            </Form.Select>
                        </div>
                        {/* Upload Area */}
                        <div id="uploadArea" className="upload-area">
                            {/* Header */}
                            <div className="upload-area__header">
                                <h1 className="upload-area__title">Upload your file</h1>
                                <p className="upload-area__paragraph">
                                    File should be an image
                                    <strong className="upload-area__tooltip">
                                    Like
                                    <span className="upload-area__tooltip-data"></span> {/* Data from JS */}
                                    </strong>
                                </p>
                            </div>

                            {/* Drop Zone */}
                            <div id="dropZoon" className="upload-area__drop-zoon drop-zoon">
                                <div className="icon-container">
                                    <img
                                        src={UploadFileIcon}
                                        alt="upload-icon"
                                        id="upload-icon"
                                        className=""
                                        draggable="false"
                                    />
                                </div>
                                
                                <span className="drop-zoon__icon">
                                    <i className="bx bxs-file-image"></i>
                                </span>
                                <p className="drop-zoon__paragraph">Drop your file here or Click to browse</p>
                                <span id="loadingText" className="drop-zoon__loading-text">Please Wait</span>
                                <img
                                    src=""
                                    alt="Preview"
                                    id="previewImage"
                                    className="drop-zoon__preview-image"
                                    draggable="false"
                                />
                                <input
                                    type="file"
                                    id="fileInput"
                                    className="drop-zoon__file-input"
                                    accept="image/*"
                                />
                            </div>

                            {/* File Details */}
                            <div id="fileDetails" className="upload-area__file-details file-details">
                            <h3 className="file-details__title">Uploaded File</h3>

                            <div id="uploadedFile" className="uploaded-file">
                                <div className="uploaded-file__icon-container">
                                <i className="bx bxs-file-blank uploaded-file__icon"></i>
                                <span className="uploaded-file__icon-text"></span>
                                </div>

                                <div id="uploadedFileInfo" className="uploaded-file__info">
                                <span className="uploaded-file__name">Project 1</span>
                                <span className="uploaded-file__counter">0%</span>
                                </div>
                            </div>
                            </div>

                            {/* Submit Button */}
                            <button id="submitBtn" className="btn btn-dotconnect btn-lg w-100 mt-3">
                            Submit
                            </button>
                        </div>
                        {/* End Upload Area */}
                        </div>
                    </div>
                    </Form>
                </div>
            </div>
        </div>
        {/* <!-- main footer --> */}
        <Footer />  
        </>
    )
}

export default ModernTradeNewFileUpload;